import _ from 'lodash'
import { I18n } from '@front/volcanion'
class Callbacks {
  static onKeyDownHandler(ctrlKeyMap, baseKeyMap) {
    return function onKeyDown(e) {
      const { altKey, ctrlKey } = e
      !!ctrlKey && ctrlKeyMap(e)
      !altKey && !ctrlKey && baseKeyMap(e)
    }
  }
  static ctrlKeyMapHandler(refuse, billing_status, canModify, openNotification) {
    return async function ctrlKeyMap(event) {
      const { key } = event
      if (key === 'F12') {
        event.preventDefault()
        if (_.includes(['valid', 'transmit', 'closed', 'to_validate'], billing_status))
          return
        if (!canModify) {
          openNotification(I18n.t('action.denied'), { variant: 'error' })
          return
        }
        refuse()
      } else {
        return false
      }
    }
  }
  static baseKeyMapHandler(approve, billing_status, canModify, openNotification) {
    return async function baseKeyMap(event) {
      const { key } = event
      if (key === 'F12') {
        event.preventDefault()
        if (_.includes(['valid', 'transmit', 'closed'], billing_status))
          return
        if (!canModify) {
          openNotification(I18n.t('action.denied'), { variant: 'error' })
          return
        }
        approve()
      } else {
        return false
      }
    }
  }
}

export default Callbacks
